export const logos = [
  {
    name: "Aegea",
    logo: "/lovable-uploads/aegea.webp",
  },
  {
    name: "Andorinha Hiper",
    logo: "/lovable-uploads/andorinha.webp",
  },
  {
    name: "Armazém da Cerveja",
    logo: "/lovable-uploads/armazem-2.webp",
  },
  {
    name: "Banco do Brasil",
    logo: "/lovable-uploads/banco-do-brasil.webp",
  },
  {
    name: "BNB",
    logo: "/lovable-uploads/bnb.webp",
  },
  {
    name: "Bodytech",
    logo: "/lovable-uploads/bodytech-logo.png",
  },
  {
    name: "Correios",
    logo: "/lovable-uploads/correios-logo.png",
  },
  {
    name: "Dasa",
    logo: "/lovable-uploads/dasa.webp",
  },
  {
    name: "Frigocopa",
    logo: "/lovable-uploads/frigocopa.webp",
  },
  {
    name: "Hapvida",
    logo: "/lovable-uploads/hapvida.webp",
  },
  {
    name: "LBV",
    logo: "/lovable-uploads/lbv-4.webp",
  },
  {
    name: "McDonalds",
    logo: "/lovable-uploads/mcdonalds-logo-5.webp",
  },
  {
    name: "Metrô",
    logo: "/lovable-uploads/metro.webp",
  },
  {
    name: "RD Saúde",
    logo: "/lovable-uploads/rd-saude-logo.svg",
  },
  {
    name: "Real",
    logo: "/lovable-uploads/real-4.webp",
  },
  {
    name: "RedeDor",
    logo: "/lovable-uploads/rede-dor.png",
  },
  {
    name: "Santander",
    logo: "/lovable-uploads/santander-logo.png",
  },
  {
    name: "São Paulo Yacht Club",
    logo: "/lovable-uploads/yacht_club.webp",
  },
  {
    name: "Smart Fit",
    logo: "/lovable-uploads/smartfit-logo.png",
  },
  { name: "TIM", logo: "/lovable-uploads/tim-logo.png" },
  {
    name: "Via Varejo",
    logo: "/lovable-uploads/viavarejo-logo.png",
  },
];
